var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mini-quote-graph" },
    [
      _c("v-chart", {
        ref: "vgraph",
        attrs: { autoresize: true, "manual-update": true },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }